import { useEffect, useState } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import HelpIcon from '@mui/icons-material/Help';
import Primarytheme from '../utility/theme';
import { fetchPimResource } from './PimProxyModule';

export default function AkeneoChannelPicker({ conf, setConf, groupKey, i }) {
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [options, setOptions] = useState([]);

    useEffect(() => {
        const load = async () => {
            setLoading(true);
            const items = await fetchPimResource(setError, conf.project_id, 'akeneo', 'channels');
            if (items) setOptions(items);
            setLoading(false);
        };
        load();
    }, []);

    const handleChange = (_, newValue) => {
        const newConf = { ...conf };
        newConf.integrationsOptions[groupKey][i].value = newValue;
        setConf(newConf);
    };

    return (
        <Stack sx={{ mb: '1em', mt: '2em' }}>
            {error && <Alert severity="error" variant="outlined" sx={{ mb: 1 }}>{error}</Alert>}
            <Stack direction="row" alignItems="center">
                <Autocomplete
                    id="akeneo-channel-picker"
                    size="small"
                    options={options}
                    getOptionLabel={(o) => o.label || o.code || ''}
                    isOptionEqualToValue={(o, v) => o.code === v.code}
                    value={conf.integrationsOptions[groupKey][i].value || null}
                    onChange={handleChange}
                    loading={loading}
                    disabled={!!error}
                    noOptionsText="No channels available"
                    clearOnEscape
                    sx={{ maxWidth: 300, flexGrow: 1 }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={conf.integrationsOptions[groupKey][i].nome || 'Channel'}
                            error={!!error}
                            slotProps={{
                                input: {
                                    ...params.InputProps,
                                    endAdornment: (
                                        <>
                                            {loading && <CircularProgress color="inherit" size={20} />}
                                            {params.InputProps.endAdornment}
                                        </>
                                    ),
                                },
                            }}
                        />
                    )}
                />
                <Tooltip title={<Typography variant="caption">{conf.integrationsOptions[groupKey][i].descrizione}</Typography>}>
                    <HelpIcon sx={{ fontSize: '1em', ml: '0.5em', color: Primarytheme.palette.neutral.main }} />
                </Tooltip>
            </Stack>
        </Stack>
    );
}
